import api from "./api";

// 智能体用户删除
export const deleteAgentUser = async ({ agentId, userId, roleType }: { agentId: string; userId: string; roleType: number }) => {
  const res = await api.post<unknown>("/agent-v2/delete-agent-user", {
    agent_id: agentId,
    user_id: userId,
    role_type: roleType,
  });
  return res;
};
